
import React, {FC} from 'react';
import Button from 'components/Button';
import {Select} from 'templates/reports/Section/ScanImages/ImageHistory/select';

import * as styles from './styles.module.scss';

type SelectorProps = {
	select: Select
}

const Selector: FC<SelectorProps> = ({select: s}) => {
	const buttons = s.options.map(({key, title}) => (
		<Button
			variant={key === s.active ? 'primary' : 'outline'}
			onClick={() => s.select(key)}
			key={key}
		>
			{title}
		</Button>
	));

	return (
		<div className={styles.selector}>
			<div>{buttons.slice(0, 2)}</div>
			<div>{buttons.slice(2, 4)}</div>
		</div>
	);
};

export default Selector;
